// Puritas V2 — mechanical motion + live dispatch clock
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var motionOn = function () { return document.body.getAttribute('data-motion') === 'on' && !reduced; };

  /* ---------- scroll progress hairline ---------- */
  var progress = document.querySelector('.progress');
  function onScroll() {
    var doc = document.documentElement;
    var max = doc.scrollHeight - window.innerHeight;
    var p = max > 0 ? Math.min(1, window.scrollY / max) : 0;
    if (progress) progress.style.transform = 'scaleX(' + p + ')';
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- reveals (scroll-driven; IntersectionObserver-independent) ----------
     IntersectionObserver does not fire reliably inside some embedded / preview
     iframes. Relying on it left every reveal stuck in its hidden pre-animation
     state (invisible body copy). Drive reveals from an initial on-load pass plus
     scroll/resize using getBoundingClientRect, which always works — and keep an
     IO as a bonus where it is available. */
  var revealEls = [].slice.call(
    document.querySelectorAll('.reveal, .rise, .draw, [data-counter], [data-typer]')
  );

  function reveal(el) {
    if (!el || el.classList.contains('in')) return;
    el.classList.add('in');
    if (el.hasAttribute('data-counter')) startCounter(el);
    if (el.hasAttribute('data-typer')) startTyper(el);
  }

  function checkReveals() {
    var trigger = window.innerHeight * 0.88;
    for (var i = revealEls.length - 1; i >= 0; i--) {
      var el = revealEls[i];
      var r = el.getBoundingClientRect();
      // reveal once the top crosses into the lower viewport, or if the element
      // already sits at/above the fold (e.g. reload partway down the page)
      if ((r.top < trigger && r.bottom > 0) || r.top < 0) {
        reveal(el);
        revealEls.splice(i, 1);
      }
    }
  }

  var revealScheduled = false;
  function onRevealScroll() {
    if (revealScheduled) return;
    revealScheduled = true;
    requestAnimationFrame(function () {
      revealScheduled = false;
      checkReveals();
    });
  }
  window.addEventListener('scroll', onRevealScroll, { passive: true });
  window.addEventListener('resize', onRevealScroll, { passive: true });

  // Bonus: if IntersectionObserver works here, let it reveal on scroll too.
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          reveal(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.25 });
    revealEls.forEach(function (el) { io.observe(el); });
  }

  // Guaranteed initial pass + failsafes for late layout/font settling.
  checkReveals();
  window.addEventListener('load', checkReveals);
  setTimeout(checkReveals, 400);

  /* ---------- purity counter ---------- */
  function startCounter(el) {
    var target = parseFloat(el.getAttribute('data-counter'));
    var numEl = el.querySelector('.num');
    if (!numEl) return;
    if (!motionOn()) { numEl.textContent = target.toFixed(2); return; }
    var dur = 2200;
    var t0 = null;
    function ease(t) { return 1 - Math.pow(1 - t, 4); }
    function frame(ts) {
      if (t0 === null) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur);
      numEl.textContent = (target * ease(p)).toFixed(2);
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  /* ---------- sequence typer ---------- */
  function startTyper(el) {
    var full = el.getAttribute('data-typer');
    var out = el.querySelector('.seq-out');
    if (!out) return;
    if (!motionOn()) { out.textContent = full; return; }
    el.classList.add('typing');
    var i = 0;
    var iv = setInterval(function () {
      i += 1;
      out.textContent = full.slice(0, i);
      if (i >= full.length) {
        clearInterval(iv);
        el.classList.remove('typing');
      }
    }, 28);
  }

  /* ---------- dispatch clock ---------- */
  var timerEls = document.querySelectorAll('.js-cutoff-timer');
  var labelEls = document.querySelectorAll('.js-cutoff-label');
  var CUTOFF = 14 * 3600;
  var fmt = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    weekday: 'short', hour: '2-digit', minute: '2-digit', second: '2-digit',
    hour12: false
  });
  var DAY_NAMES = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  var LABELS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function pad(n) { return n < 10 ? '0' + n : '' + n; }
  function tick() {
    var parts = {};
    fmt.formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var day = DAY_NAMES[parts.weekday];
    var secs = (parseInt(parts.hour, 10) % 24) * 3600 + parseInt(parts.minute, 10) * 60 + parseInt(parts.second, 10);
    var remaining, label;
    if (day >= 1 && day <= 5 && secs < CUTOFF) {
      remaining = CUTOFF - secs;
      label = 'ships today';
    } else {
      var ahead = 1;
      while ((day + ahead) % 7 === 0 || (day + ahead) % 7 === 6) ahead++;
      remaining = ahead * 86400 - secs + CUTOFF;
      label = ahead === 1 ? 'ships tomorrow' : 'ships ' + LABELS[(day + ahead) % 7];
    }
    var h = Math.floor(remaining / 3600);
    var m = Math.floor((remaining % 3600) / 60);
    var s = remaining % 60;
    var text = pad(h) + ':' + pad(m) + ':' + pad(s);
    timerEls.forEach(function (el) { el.textContent = text; });
    labelEls.forEach(function (el) { el.textContent = label; });
  }
  tick();
  setInterval(tick, 1000);
})();
